<template>
  <div class="page-content bg-light">
    <div class="px-10">
      <bx-box class="d-flex justify-content-start">
        <h4 class="font-weight-bold my-10 non-selectable">Widgets</h4>
        <p class="font-weight-bold non-selectable">Graphs</p>
      </bx-box>
      <bx-box class="d-flex">
        <div class="d-flex justify-content-around">
          <div class="mr-5">
            <h6 class="font-weight-bold my-5 non-selectable">
              Bars with Counters
            </h6>
            <v-card class="py-2" elevation="10" height="350">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Bars with Counters Chart</span>
              </v-tooltip>
              <apexchart
                type="line"
                height="240"
                width="330"
                class="mt-5"
                :options="barCountersOption"
                :series="barCountersData.series"
              ></apexchart>
              <v-divider class="my-0"></v-divider>
              <div class="d-flex justify-content-around">
                <div class="text-center py-3">
                  <p class="bar-stats mb-0">342.000 €</p>
                  <p class="subText mb-0">Total sales</p>
                </div>
                <div>
                  <v-divider class="my-0 mx-0" vertical></v-divider>
                </div>
                <div class="text-center py-3">
                  <p class="bar-stats mb-0">200.000 €</p>
                  <p class="subText mb-0">Total spendings</p>
                </div>
              </div>
            </v-card>
          </div>
          <div class="mr-5">
            <h6 class="font-weight-bold my-5 non-selectable">Bars vertical</h6>
            <v-card class="py-2" elevation="10" height="220" rounded>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Bars vertical Chart</span>
              </v-tooltip>
              <apexchart
                type="line"
                height="180"
                width="325"
                class="mt-5"
                :options="barVerticalOption"
                :series="barVerticalData.series"
              ></apexchart>
            </v-card>
          </div>
          <div>
            <h6 style="color: #f8f9fa" class="my-5">-</h6>
            <v-card class="py-2" elevation="10" height="350" rounded>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Proposals open Chart</span>
              </v-tooltip>
              <apexchart
                type="line"
                height="300"
                width="500"
                class="mt-5"
                :options="proposalsOption"
                :series="proposalsData.series"
              ></apexchart>
            </v-card>
          </div>
        </div>
      </bx-box>
      <bx-box>
        <v-card class="mt-10 py-2" elevation="10" height="450">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                dense
                color="primary"
                dark
                class="tool-tip"
                v-bind="attrs"
                v-on="on"
              >
                mdi-help-circle
              </v-icon>
            </template>
            <span>Proposals Chart</span>
          </v-tooltip>
          <apexchart
            type="line"
            height="200"
            class="mt-5"
            :options="proposalsOption2"
            :series="proposalsData2.series"
          ></apexchart>
          <apexchart
            type="line"
            height="200"
            :options="proposalsOption1"
            :series="proposalsData1.series"
          ></apexchart>
        </v-card>
      </bx-box>

      <bx-box class="d-flex justify-content-start mt-10">
        <h6 class="font-weight-bold my-5 non-selectable">Bars with Wave</h6>
        <div class="d-flex justify-content-between">
          <div class="mr-5">
            <v-card class="py-2" elevation="10" height="350" width="500">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Wave Chart</span>
              </v-tooltip>
              <apexchart
                type="line"
                height="300"
                width="500"
                class="mt-5"
                :options="barWithWaveOption1"
                :series="barWithWaveData1.series"
              ></apexchart>
            </v-card>
          </div>
          <div>
            <v-card class="py-2" elevation="10" height="350" width="500">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Wave Chart</span>
              </v-tooltip>
              <apexchart
                type="line"
                height="300"
                width="500"
                class="mt-5"
                :options="barWithWaveOption2"
                :series="barWithWaveData2.series"
              ></apexchart>
            </v-card>
          </div>
        </div>
      </bx-box>
      <bx-box class="d-flex justify-content-start mt-10">
        <h6 class="font-weight-bold my-5 non-selectable">Wave</h6>
        <v-card class="py-2" elevation="10" height="350" width="600">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                dense
                color="primary"
                dark
                class="tool-tip"
                v-bind="attrs"
                v-on="on"
              >
                mdi-help-circle
              </v-icon>
            </template>
            <span>Wave Chart</span>
          </v-tooltip>
          <apexchart
            type="area"
            height="300"
            width="600"
            class="mt-5"
            :options="waveOptions"
            :series="waveData.series"
          ></apexchart>
        </v-card>
      </bx-box>
      <bx-box>
        <v-card class="mt-10 py-5" elevation="10" height="350">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                dense
                color="primary"
                dark
                class="tool-tip"
                v-bind="attrs"
                v-on="on"
              >
                mdi-help-circle
              </v-icon>
            </template>
            <span>Convertion Info Chart</span>
          </v-tooltip>
          <apexchart
            type="line"
            height="300"
            class="mt-5"
            :options="convertionChartOption"
            :series="convertionChartData.series"
          ></apexchart>
        </v-card>
      </bx-box>

      <bx-box class="mt-10">
        <h6 class="font-weight-bold my-5 non-selectable">Geometric</h6>
        <v-card class="py-2" elevation="10" height="380" width="600">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                dense
                color="primary"
                dark
                class="tool-tip"
                v-bind="attrs"
                v-on="on"
              >
                mdi-help-circle
              </v-icon>
            </template>
            <span>Wave Chart</span>
          </v-tooltip>
          <apexchart
            type="area"
            height="350"
            width="600"
            class="mt-5"
            :options="geometricChartOptions"
            :series="geometricChartData.series"
          ></apexchart>
        </v-card>
      </bx-box>
      <bx-box class="d-flex mt-16">
        <div class="d-flex justify-content-around">
          <div class="mr-5">
            <h6 class="font-weight-bold my-5 non-selectable">Pie</h6>
            <v-card
              class="mx-auto d-flex align-items-center justify-content-start"
              :max-width="isMobile ? 300 : 450"
              elevation="10"
              height="340"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Pie Chart</span>
              </v-tooltip>
              <apexchart
                type="donut"
                height="330"
                :width="isMobile ? 300 : 450"
                :options="pieChartOptions"
                :series="pieSeries.series"
              ></apexchart>
            </v-card>
          </div>
          <div class="mr-5">
            <h6 class="font-weight-bold my-5 non-selectable">Pie Mobile</h6>
            <v-card
              class="mx-auto d-flex align-items-center justify-content-start"
              :max-width="350"
              elevation="10"
              height="400"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Pie Mobile Chart</span>
              </v-tooltip>
              <apexchart
                type="donut"
                height="450"
                width="300"
                :options="pieChartOptions"
                :series="pieSeries.series"
              ></apexchart>
            </v-card>
          </div>
          <div>
            <h6 class="font-weight-bold my-5 non-selectable">Basic Pie</h6>
            <v-card
              class="mx-auto d-flex align-items-center justify-content-start"
              :max-width="350"
              elevation="10"
              height="320"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Basic Pie Chart</span>
              </v-tooltip>
              <apexchart
                type="donut"
                height="300"
                width="300"
                :options="pieBasicOptions"
                :series="pieBasicSeries.series"
              ></apexchart>
            </v-card>
          </div>
        </div>
      </bx-box>
      <bx-box class="d-flex mt-16">
        <h6 class="font-weight-bold my-5 non-selectable">Counters</h6>
        <div class="d-flex justify-content-around">
          <div class="mr-5">
            <h6 class="font-weight-bold my-5 non-selectable">Bar Numeric</h6>
            <v-card class="my-5 py-1" elevation="10" height="100" width="375">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Sales Chart</span>
              </v-tooltip>
              <div class="mx-5 my-2">
                <div class="d-flex justify-content-between">
                  <div>
                    <p class="heading mb-0 non-selectable">Total sales</p>
                    <p class="subText mb-0 non-selectable">
                      Week to week performance
                    </p>
                  </div>
                  <div class="d-flex align-item-center mx-3">
                    <p class="stats mb-0 mx-2 non-selectable">1.345</p>
                    <v-icon dense color="#66DA26">
                      mdi-arrow-up
                    </v-icon>
                  </div>
                </div>
                <v-progress-linear
                  class="mt-5"
                  value="83.54"
                  :color="progressBasedColor(83.54)"
                  background-color="#b5bfbd"
                  rounded
                  height="5"
                ></v-progress-linear>
              </div>
            </v-card>
            <v-card class="my-5 py-1" elevation="10" height="100" width="375">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Sales Chart</span>
              </v-tooltip>
              <div class="mx-5 my-0">
                <div class="d-flex justify-content-around">
                  <div>
                    <p class="heading mb-0 non-selectable">Total sales</p>
                    <p class="subText mb-0 non-selectable">
                      {{ barNumericChart.year }}
                    </p>
                  </div>
                  <div class="d-flex align-item-center mx-1">
                    <p class="stats mb-0 mx-0">
                      {{ barNumericChart.currentSales }} €
                    </p>
                    <v-icon dense color="#66DA26">
                      mdi-arrow-up
                    </v-icon>
                  </div>
                </div>
                <v-progress-linear
                  class="mt-0"
                  :value="
                    (barNumericChart.currentSales /
                      barNumericChart.totalSales) *
                      100
                  "
                  :color="
                    progressBasedColor(
                      (barNumericChart.currentSales /
                        barNumericChart.totalSales) *
                        100
                    )
                  "
                  background-color="#b5bfbd"
                  rounded
                  height="5"
                ></v-progress-linear>
                <div class="mt-1 d-flex justify-content-between">
                  <div>
                    <p class="subText-black mb-0 non-selectable">
                      {{
                        Math.round(
                          (barNumericChart.currentSales /
                            barNumericChart.totalSales) *
                            100
                        )
                      }}%
                    </p>
                  </div>
                  <div class="d-flex align-item-center mx-3">
                    <p class="subText mb-0 mx-2 non-selectable">
                      {{ barNumericChart.totalSales.toFixed(3) }} €
                    </p>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
          <div style="width:375px" class="mr-5">
            <h6 class="font-weight-bold my-5 non-selectable">Graph</h6>
            <v-card class="my-5 py-1" elevation="10" height="100" width="375">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Sales Chart</span>
              </v-tooltip>
              <div
                class="mt-0 d-flex justify-content-between align-items-center"
              >
                <div class="mt-0 ml-5">
                  <p class="stats mb-0 non-selectable">1.345</p>
                  <p class="subText mb-0 non-selectable">News Tasks</p>
                </div>
                <div class="mr-5">
                  <apexchart
                    type="line"
                    height="70"
                    width="180"
                    class="mt-5"
                    :options="counterGraphOption"
                    :series="counterGraphData.series"
                  ></apexchart>
                </div>
              </div>
            </v-card>
            <v-card class="my-5 py-1" elevation="10" height="100" width="375">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Sales Chart</span>
              </v-tooltip>
              <div
                class="mt-0 d-flex justify-content-between align-items-center"
              >
                <div class="ml-5 my-5">
                  <p class="heading mb-0 non-selectable">MRR Current Year</p>
                  <p class="stats mb-0 non-selectable">43.256 €</p>
                </div>
                <div class="mt-5 mr-5">
                  <apexchart
                    type="line"
                    height="70"
                    width="180"
                    :options="counterGraphOption"
                    :series="counterGraphData.series"
                  ></apexchart>
                </div>
              </div>
            </v-card>
          </div>
          <div>
            <h6 class="font-weight-bold my-5 non-selectable">
              Numeric with Icon
            </h6>
            <v-card
              class="my-5 align-items-center"
              elevation="10"
              height="100"
              width="375"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Sales Chart</span>
              </v-tooltip>
              <div
                class="mt-1 d-flex justify-content-between align-items-center"
              >
                <div class="mx-7 my-5">
                  <p class="stats mb-0 non-selectable">1.345</p>
                  <p class="subText mb-0 non-selectable">News Tasks</p>
                </div>
                <div class="d-flex align-item-center mx-10">
                  <v-btn
                    class="rounded-lg"
                    color="#66DA26"
                    elevation="2"
                    icon
                    large
                    outlined
                    raised
                    tile
                    @click="btnClicked('Numeric with Icon')"
                  >
                    <span
                      class="iconify"
                      data-icon="codicon:search"
                      data-inline="false"
                    ></span>
                  </v-btn>
                </div>
              </div>
            </v-card>
            <v-card
              class="d-flex justify-content-center align-items-center my-5 align-items-center"
              elevation="10"
              height="100"
              width="150"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Sales Chart</span>
              </v-tooltip>
              <div>
                <p class="stats mb-0 non-selectable">1.345</p>
                <p class="subText mb-0 non-selectable">News Tasks</p>
              </div>
            </v-card>
          </div>
        </div>
        <div class="d-flex mr-5">
          <div>
            <h6 class="font-weight-bold mt-15 non-selectable">Icon</h6>
            <v-card
              class="my-5 py-1 mr-5"
              elevation="10"
              height="100"
              width="375"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Sales Chart</span>
              </v-tooltip>
              <div
                class="mt-1 d-flex justify-content-between align-items-center"
              >
                <div class="mx-7 my-5">
                  <p class="subText-black mb-0 non-selectable">News Tasks</p>
                  <div class="d-flex align-item-center">
                    <p class="stats mb-0 mr-2 non-selectable">1.345</p>
                    <v-icon dense color="#0074ff">
                      mdi-arrow-up
                    </v-icon>
                  </div>
                </div>
                <div class="d-flex align-item-center mx-10">
                  <v-btn
                    class="rounded-lg"
                    color="#0074ff"
                    elevation="2"
                    icon
                    large
                    outlined
                    raised
                    tile
                    @click="btnClicked('Icon')"
                  >
                    <span
                      class="iconify"
                      data-icon="codicon:search"
                      data-inline="false"
                    ></span>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </div>
          <div>
            <h6 class="font-weight-bold mt-15 non-selectable">Progress</h6>
            <v-card class="my-5 py-3" elevation="10" height="100" width="375">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    color="primary"
                    dark
                    class="tool-tip"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>Sales Chart</span>
              </v-tooltip>
              <div
                class="mt-1 d-flex justify-content-between align-items-center"
              >
                <div class="mx-7 my-0">
                  <p class="subText-black mb-0 non-selectable">News Sales</p>
                  <div class="d-flex align-item-center">
                    <p class="stats mb-0 mr-2 non-selectable">1.345</p>
                  </div>
                </div>
                <div class="d-flex align-items-end mx-10  mt-5">
                  <p class="subText-black mb-0 non-selectable">21%</p>
                </div>
              </div>
              <div class="mx-7">
                <v-progress-linear
                  class="mt-1"
                  value="21"
                  :color="progressBasedColor(21)"
                  background-color="#b5bfbd"
                  rounded
                  height="5"
                ></v-progress-linear>
              </div>
            </v-card>
          </div>
        </div>
      </bx-box>

      <bx-box class="d-flex justify-content-start mt-15">
        <v-card class="py-2" elevation="5" height="200" width="1200">
          <h6 class="font-weight-bold ml-5 my-5 non-selectable">
            Progress bars
          </h6>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                dense
                color="primary"
                dark
                class="tool-tip"
                v-bind="attrs"
                v-on="on"
              >
                mdi-help-circle
              </v-icon>
            </template>
            <span>Progress Bars Chart</span>
          </v-tooltip>
          <div class="d-flex justify-content-between">
            <div style="width:120px" class="ml-5 mr-3 my-5">
              <h6 class="font-weight-bold non-selectable">Resting</h6>
              <v-progress-linear
                class="my-5"
                value="0"
                color="#ff3b00"
                background-color="#b5bfbd"
                rounded
                height="5"
              ></v-progress-linear>
            </div>
            <div style="width:120px" class="mx-3 my-5">
              <h6 class="font-weight-bold non-selectable">Stage 1</h6>
              <v-progress-linear
                class="my-5"
                value="15"
                color="#fa8282"
                background-color="#b5bfbd"
                rounded
                height="5"
              ></v-progress-linear>
            </div>
            <div style="width:120px" class="mx-3 my-5">
              <h6 class="font-weight-bold non-selectable">Stage 2</h6>
              <v-progress-linear
                class="my-5"
                value="30"
                color="#facc82"
                background-color="#b5bfbd"
                rounded
                height="5"
              ></v-progress-linear>
            </div>
            <div style="width:120px" class="mx-3 my-5">
              <h6 class="font-weight-bold non-selectable">DDAE I</h6>
              <v-progress-linear
                class="my-5"
                value="50"
                color="#faf582"
                background-color="#b5bfbd"
                rounded
                height="5"
              ></v-progress-linear>
            </div>
            <div style="width:120px" class="mx-5 my-5">
              <h6 class="font-weight-bold non-selectable">DDAE II</h6>
              <v-progress-linear
                class="my-5"
                value="70"
                color="#9efa82"
                background-color="#b5bfbd"
                rounded
                height="5"
              ></v-progress-linear>
            </div>
            <div style="width:120px" class="mx-5 my-5">
              <h6 class="font-weight-bold non-selectable">DDAE III</h6>
              <v-progress-linear
                class="my-5"
                value="90"
                color="#5dc355"
                background-color="#b5bfbd"
                rounded
                height="5"
              ></v-progress-linear>
            </div>
          </div>
        </v-card>
      </bx-box>
      <bx-box class="d-flex justify-content-start">
        <h6 class="font-weight-bold mt-15 mb-5 non-selectable">
          Stacked bar charts
        </h6>
        <v-card class="py-2" elevation="5" height="300" width="600">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                dense
                color="primary"
                dark
                class="tool-tip"
                v-bind="attrs"
                v-on="on"
              >
                mdi-help-circle
              </v-icon>
            </template>
            <span>Stacked Chart</span>
          </v-tooltip>
          <apexchart
            type="bar"
            height="275"
            width="600"
            class="mt-5"
            :options="stackedOptions"
            :series="stackedChart.series"
          ></apexchart>
        </v-card>
      </bx-box>
    </div>
  </div>
</template>

<script>
import common from "@/utils/common";
import chartMixin from "@/utils/chartMixin";
export default {
  name: "Chart",
  mixins: [common, chartMixin],
  methods: {
    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + "k"
        : Math.sign(num) * Math.abs(num);
    },
    progressBasedColor(percent) {
      if (percent === 0) {
        return "#ff3b00";
      } else if (percent < 20) {
        return "#fa8282";
      } else if (percent < 40) {
        return "#facc82";
      } else if (percent < 60) {
        return "#faf582";
      } else if (percent < 80) {
        return "#9efa82";
      } else if (percent < 100) {
        return "#5dc355";
      }
    },
    btnClicked(btn) {
      alert(`You clicked on ${btn} Button`);
    }
  }
};
</script>
